<template>
  <div class="addevent eventdata addeventprivateclass">
    <b-form @submit.prevent="onSubmit">
      <input type="hidden" name="client" v-model="client_name" />
      <input type="hidden" name="event_type" v-model="event_type" />

      <b-card no-body class="p-3">
        <template #header>
          <b-card-sub-title class="my-0 card-subtitle-doom-yoga">{{
            action == "create" ? "New Private Class" : "Private Class Info"
          }}</b-card-sub-title>
        </template>

        <b-card-body class="pt-0">
          <EventBasicData
            :client_name="client_name"
            field_name="class"
            :event_name.sync="class_name"
            :event_description.sync="class_description"
            :is_event_in_person.sync="is_class_in_person"
            :is_event_recurring.sync="is_class_recurring"
            :cover_image.sync="cover_image"
            :preview.sync="preview"
            :cover_image_id.sync="cover_image_id"
          />

          <b-row>
            <b-col md="7">
              <b-row>
                <b-col>
                  <b-form-group
                    label="Availability"
                    label-for="availability"
                    :availability="availability"
                    :label-class="{
                      'form-label-doomyoga': client_name == 'DY',
                    }"
                  >
                    <b-form-textarea
                      id="availability"
                      v-bind:class="{
                        'form-control-doomyoga': client_name == 'DY',
                      }"
                      v-model="availability"
                      :availability="availability"
                      v-b-modal="'business-hours-modal'"
                      rows="4"
                      required
                    ></b-form-textarea>
                  </b-form-group>
                  <b-modal
                    id="business-hours-modal"
                    modal-class="business-hours-modal-doomyoga"
                    title="Availability"
                    hide-footer
                  >
                    <b-form @submit.prevent="clickConfirm"
                      ><business-hours
                        :days="days"
                        :locations="locations"
                        type="select"
                        @updated-hours="updatedHours"
                        color="#CA7B80"
                        :switchWidth="80"
                      ></business-hours>

                      <b-row class="justify-content-center w-100">
                        <b-col lg="3" md="6" class="text-center">
                          <b-button
                            variant="doomyoga-primary"
                            class="
                              btn-bumblebee btn-doomyoga btn-doom-yoga-submit
                              w-100
                            "
                            type="submit"
                          >
                            Yes
                          </b-button>
                        </b-col>

                        <b-col lg="3" md="6" class="text-center">
                          <b-button
                            type="button"
                            variant="doomyoga-danger-outline"
                            class="
                              btn-bumblebee btn-doomyoga btn-doom-yoga-submit
                              w-100
                            "
                            @click="closeModal"
                          >
                            Cancel
                          </b-button>
                        </b-col>
                      </b-row>
                    </b-form></b-modal
                  >
                </b-col></b-row
              >
            </b-col>
          </b-row>
          <EventOtherData
            :client_name="client_name"
            field_name="class"
            :capacity_per_session.sync="capacity_per_session"
          />
        </b-card-body>
      </b-card>
      <event-payment
        :price_per_session.sync="price_per_session"
        :amount.sync="amount"
        :invalid_session_price="invalid_session_price"
        client_name="DY"
      />
      <event-location
        :location.sync="location"
        :invalid_location="invalid_location"
        client_name="DY"
        :locations="locations"
      />
      <b-row>
        <b-col lg="3" offset-lg="9" md="4" offset-md="8" sm="6" offset-sm="6">
          <b-button
            type="submit"
            variant="doomyoga-primary"
            class="btn-bumblebee btn-doomyoga btn-doom-yoga-submit w-100"
            v-if="!is_loading"
          >
            {{ action }} Class </b-button
          ><b-button
            type="button"
            disabled
            variant="doomyoga-primary"
            class="btn-bumblebee btn-doomyoga btn-doom-yoga-submit w-100"
            v-else
          >
            <b-spinner small label="Small Spinner" variant="light"></b-spinner>
            Loading
          </b-button>
        </b-col></b-row
      >
    </b-form>
  </div>
</template>

<script>
import EventBasicData from "@/components/events/BasicData.vue";
import EventOtherData from "@/components/events/OtherData.vue";
import EventPayment from "@/components/events/Payment.vue";
import EventLocation from "@/components/events/Location.vue";
import BusinessHours from "@/components/vue-business-hours/BusinessHoursDoomYoga.vue";
import $ from "jquery";
import moment from "moment";
import axios from "axios";

let days_empty = {
  sunday: [
    {
      open: "",
      close: "",
      id: "1",
      isOpen: false,
      location: "",
    },
  ],
  monday: [
    {
      open: "",
      close: "",
      id: "2",
      isOpen: false,
      location: "",
    },
  ],
  tuesday: [
    {
      open: "",
      close: "",
      id: "3",
      isOpen: false,
      location: "",
    },
  ],
  wednesday: [
    {
      open: "",
      close: "",
      id: "4",
      isOpen: false,
      location: "",
    },
  ],
  thursday: [
    {
      open: "",
      close: "",
      id: "5",
      isOpen: false,
      location: "",
    },
  ],
  friday: [
    {
      open: "",
      close: "",
      id: "6",
      isOpen: false,
      location: "",
    },
  ],
  saturday: [
    {
      open: "",
      close: "",
      id: "7",
      isOpen: false,
      location: "",
    },
  ],
};

export default {
  name: "EventPrivateClassInfo",
  components: {
    EventBasicData,
    EventOtherData,
    EventLocation,
    EventPayment,
    BusinessHours,
  },
  props: ["action", "locations"],
  data() {
    return {
      client_name: "DY",
      event_type: "private_class",

      // locations: [
      //   { text: "ZOOM ONLINE", id: "ZOOM ONLINE" },
      //   { text: "Kimberley Street, London", id: "Kimberley Street, London" },
      //   { text: "Dublin, Ireland", id: "Dublin, Ireland" },
      //   { text: "Studio Doom Yoga, London", id: "Studio Doom Yoga, London" },
      // ],

      class_name: "",
      class_description: "",
      cover_image: null,
      preview: null,
      cover_image_id: null,

      capacity_per_session: null,
      is_class_in_person: "",
      is_class_recurring: "",

      location: "",
      invalid_location: false,

      price_per_session: "",
      amount: "",
      invalid_session_price: false,

      availability: "",
      days_backup: null,
      days: {
        sunday: [
          {
            open: "",
            close: "",
            id: "1",
            isOpen: false,
            location: "",
          },
        ],
        monday: [
          {
            open: "",
            close: "",
            id: "2",
            isOpen: false,
            location: "",
          },
        ],
        tuesday: [
          {
            open: "",
            close: "",
            id: "3",
            isOpen: false,
            location: "",
          },
        ],
        wednesday: [
          {
            open: "",
            close: "",
            id: "4",
            isOpen: false,
            location: "",
          },
        ],
        thursday: [
          {
            open: "",
            close: "",
            id: "5",
            isOpen: false,
            location: "",
          },
        ],
        friday: [
          {
            open: "",
            close: "",
            id: "6",
            isOpen: false,
            location: "",
          },
        ],
        saturday: [
          {
            open: "",
            close: "",
            id: "7",
            isOpen: false,
            location: "",
          },
        ],
      },
      is_loading: false,
      swal_confirm_button_class: "",
      swal_container_class: "",
    };
  },
  mounted() {
    // console.log(JSON.parse(window.localStorage.getItem("user")));
    // console.log(this.client_name);
    if (this.client_name == "DY") {
      this.swal_confirm_button_class =
        "btn btn-bumblebee btn-doomyoga  btn-doomyoga-primary";
      this.swal_container_class = "swal-container-dy";
    }

    if (this.action === "update") {
      axios
        .get("event/events/" + this.$route.params.id, {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            client: this.client_name,
            Authorization:
              "Bearer " +
              JSON.parse(window.localStorage.getItem("user")).access_token,
          },
        })
        .then((response) => {
          console.log(response);
          // this.events = response.data;
          this.setEventData(response.data);
        });

      console.log("update event id " + this.$route.params.id);
      this.event_id = this.$route.params.id;
    }
  },
  methods: {
    setEventData(event) {
      console.log("in set event data ");
      console.log(event);
      this.class_name = event.name;
      this.class_description = event.description;
      this.preview = event.cover.path;

      this.is_class_in_person = event.is_person;
      this.is_class_recurring = event.is_recurring;

      this.capacity_per_session = event.capacity;

      this.price_per_session = event.price_type;
      if (event.price_type === "fixed") {
        this.amount = event.price;
      }
      console.log(event.address);
      // if (event.location_type === "online") {
      this.location = event.address;
      // }

      this.availability = event.availability;
      this.days = event.private_days;
    },
    clickIsRecuring(val) {},
    previewImage: function (event) {
      var input = event.target;
      if (input.files) {
        var reader = new FileReader();
        reader.readAsDataURL(input.files[0]);
        reader.onload = (e) => {
          this.preview = e.target.result;
        };
        this.cover_image = input.files[0];
      }
    },
    addFile(id) {
      console.log("click file " + id);
      $("#" + id).click();
    },

    clickConfirm(event) {
      console.log(this.days);
      // this.availability = this.days;

      let temp = "";
      Object.keys(this.days).forEach((key) => {
        console.log(key, this.days[key]);
        if (this.days[key][0].isOpen) {
          temp += key.charAt(0).toUpperCase() + key.slice(1) + ": ";

          this.days[key].forEach(function (element, index) {
            console.log(element, index, typeof element.open);
            if (element.open != "24hrs") {
              temp +=
                moment(element.open, "HHmm").format("hh:mm a") +
                " - " +
                moment(element.close, "HHmm").format("hh:mm a");
            } else {
              temp += element.open + " - " + element.close;
            }
            if (element.location != "") {
              temp += ", " + element.location;
            }
            temp += "/";
          });

          temp += "\n";
        }
      });
      this.availability = temp;
      this.days_backup = structuredClone(this.days);
      // this.$refs['business-hours-modal'].hide()
      this.$bvModal.hide("business-hours-modal");
    },
    closeModal() {
      if (this.availability != "") {
        this.days = structuredClone(this.days_backup);
        // this.availability = "";
      } else if (this.availability == "") {
        this.days = structuredClone(days_empty);
      }
      this.$bvModal.hide("business-hours-modal");
    },

    updatedHours: function (val) {
      // do whatever you want here
      console.log(val);
      console.log(this.days);
    },
    onSubmit(event) {
      console.log("in submit ");
      console.log(event);
      console.log(this.client_name, this.event_type);
      console.log(this.class_name);
      console.log(this.class_description);
      console.log(this.is_class_in_person, this.capacity_per_session);
      console.log(this.location);
      console.log(this.price_per_session, this.amount);
      console.log(this.availability);
      console.log(this.days);

      this.is_loading = true;

      if (this.price_per_session == "" || this.price_per_session == null) {
        this.invalid_session_price = true;
      } else {
        this.invalid_session_price = false;
      }
      if (this.location == "" || this.location == null) {
        this.invalid_location = true;
      } else {
        this.invalid_location = false;
      }
      if (!this.invalid_session_price && !this.invalid_location) {
        if (this.cover_image != null && this.preview != null) {
          console.log("send img request");

          let formData = new FormData();
          formData.append("client", this.client_name);
          formData.append("selectedfile", this.cover_image);

          axios
            .post("filesmodule/upload", formData, {
              headers: {
                Accept: "application/json",
                "Content-Type": "multipart/form-data",
                Authorization:
                  "Bearer " +
                  JSON.parse(window.localStorage.getItem("user")).access_token,
              },
            })
            .then((response) => {
              console.log(response);
              console.log(response.data);
              console.log(response.data.id);
              //this.is_loading = false;
              this.cover_image_id = response.data.id;
              this.getEventDataToSend();
            })
            .catch((error) => {
              console.log(error.response.data.error);
              console.log(error.request);
              console.log(error.message);
              this.$fire({
                // title: "Title",
                text: error.response.data.error,
                type: "error",
                timer: 5000,
                customClass: {
                  container: this.swal_container_class,
                  confirmButton: this.swal_confirm_button_class,
                },
              }).then((r) => {
                // console.log(r.value);
              });
            });
        } else {
          this.getEventDataToSend();
        }
      } else {
        this.is_loading = false;
      }
    },
    getEventDataToSend() {
      console.log("in get event data to send");
      // let formData = new FormData();
      // formData.append("client", this.client_name);
      // formData.append("type", this.event_type);

      // formData.append("name", this.class_name);
      // if (this.class_description != null) {
      //   formData.append("description", this.class_description);
      // }
      // if (this.cover_image_id != null) {
      //   formData.append("cover", this.cover_image_id);
      // }
      // formData.append("is_person", this.is_class_in_person);

      // formData.append("is_recurring", this.is_class_recurring);

      // formData.append("capacity", this.capacity_per_session);
      // formData.append("price_type", this.price_per_session);
      // formData.append("price", this.amount);
      // formData.append("location_type", "online");
      // formData.append("address", this.location);

      // formData.append("availability", this.availability);
      // formData.append("private_days", JSON.stringify(this.days));

      let requestData = {
        organizer_id: JSON.parse(window.localStorage.getItem("user")).id,
        client: this.client_name,
        type: this.event_type,
        name: this.class_name,
        description: this.class_description,
        cover: this.cover_image_id,
        is_person: this.is_class_in_person,
        is_recurring: this.is_class_recurring,
        capacity: this.capacity_per_session,
        price_type: this.price_per_session,
        price: this.amount,
        location_type: "online",
        address: this.location,
        availability: this.availability,
        private_days: this.days,
      };

      if (this.action === "create") {
        this.sendCreatePrivateRequest(requestData);
      } else if (this.action === "update") {
        this.sendUpdatePrivateRequest(requestData);
      }
    },
    sendCreatePrivateRequest(requestData) {
      axios
        .post("event/events", requestData, {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            client: this.client_name,
            Authorization:
              "Bearer " +
              JSON.parse(window.localStorage.getItem("user")).access_token,
          },
        })
        .then((response) => {
          console.log(response);
          this.is_loading = false;

          this.$fire({
            // title: "Title",
            text: "Private class is created successfully",
            type: "success",
            timer: 3000,
            customClass: {
              container: this.swal_container_class,
              confirmButton: this.swal_confirm_button_class,
            },
          }).then((r) => {
            // console.log(r.value);
            this.is_loading = false;
            this.$router.go();
          });
          // this.$swal("Class is created successfully");
          // this.$parent.$parent.isLogin = true;
          // this.$router.go({ name: "DoOmYogaDashboard" });
        })
        .catch((error) => {
          console.log(error.response);
          this.$fire({
            // title: "Title",
            text: error.response.data.error,
            type: "error",
            timer: 3000,
            customClass: {
              container: this.swal_container_class,
              confirmButton: this.swal_confirm_button_class,
            },
          }).then((r) => {
            // console.log(r.value);
            this.is_loading = false;
          });
        });
    },

    sendUpdatePrivateRequest(requestData) {
      console.log("in send update request " + this.event_id);
      console.log(requestData);
      // console.log(formData.get("name"));
      // formData.append("id", this.event_id);
      // console.log(formData.get("id"));
      console.log(this.client_name);
      // formData.append("_method", "put");

      requestData.id = this.event_id;
      requestData._method = "put";
      console.log(requestData);

      axios
        .post("event/events/" + this.event_id, requestData, {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            client: this.client_name,
            Authorization:
              "Bearer " +
              JSON.parse(window.localStorage.getItem("user")).access_token,
          },
        })
        .then((response) => {
          console.log(response);
          this.is_loading = false;

          this.$fire({
            // title: "Title",
            text: "Private class is updated successfully",
            type: "success",
            // timer: 3000,
            customClass: {
              container: this.swal_container_class,
              confirmButton: this.swal_confirm_button_class,
            },
          }).then((r) => {
            // console.log(r.value);
            this.is_loading = false;
            this.$router.go();
          });
          // this.$swal("Class is created successfully");
          // this.$parent.$parent.isLogin = true;
          // this.$router.go({ name: "DoOmYogaDashboard" });
        })
        .catch((error) => {
          console.log(error.response);
          this.$fire({
            // title: "Title",
            text: error.response.data.error,
            type: "error",
            timer: 3000,
            customClass: {
              container: this.swal_container_class,
              confirmButton: this.swal_confirm_button_class,
            },
          }).then((r) => {
            // console.log(r.value);
            this.is_loading = false;
          });
        });
    },
  },
};
</script>
<style >
@media screen and (min-width: 576px) {
  #business-hours-modal .modal-dialog {
    margin-top: 100px;
    max-width: 85%;
    width: 85%;
  }
  .modal-dialog-scrollable {
    height: calc(100% - 10rem);
  }
}
@media screen and (min-width: 768px) {
  #business-hours-modal .modal-dialog {
    max-width: 75%;
    width: 75%;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/doom_yoga/events/PrivateClassInfo.vue